export const vertical = (val = 20) => [val, 0];
export const horizontal = (val = 20) => [0, val];
export const topAndHorizontal = (val = 20) => [val, val, 0, val];
export const bottomAndHorizontal = (val = 20) => [0, val, val, val];
export const onlyTop = (val = 5) => [val, val, 0, 0];
export const onlyBottom = (val = 5) => [0, 0, val, val];
export const onlyLeft = (val = 5) => [val, 0, 0, val];
export const onlyRight = (val = 5) => [0, val, val, 0];
export const border = (color, size = 1, type = 'solid') => `${size}px ${type} ${color}`;
export const transition = (timingInMs = 150, property = 'all', mode = 'linear') => `${property} ${timingInMs}ms ${mode}`;
export const setProp = (obj, key, value) => {
    if (value) {
        obj[key] = value;
    }
    return obj;
};
export const toCssValue = (value = 20, important = false, unit = 'px') => {
    let cssRule;
    if (Array.isArray(value)) {
        cssRule = value.map((v) => ` ${v}px`).join(' ');
    }
    else {
        cssRule = `${value}px`;
    }
    if (important) {
        cssRule += ' !important';
    }
    return cssRule;
};
//# sourceMappingURL=themeUtils.js.map